export default __webpack_public_path__ + "static/media/whirpool.9dfc7ad6.svg";